import { boolean, object, string } from "yup";
import {
  booleanDefaultToFalse,
  firebaseDate,
  stringDefaultToEmpty,
} from "@poseidon/utils/yupSchemaTypes";

export const dealerSchema = object({
  companyName: stringDefaultToEmpty,
  companyNumber: stringDefaultToEmpty,
  contactName: stringDefaultToEmpty,
  contactNumber: stringDefaultToEmpty,
  contactEmail: stringDefaultToEmpty,
  address: stringDefaultToEmpty,
  postcode: stringDefaultToEmpty,
  nameOnAccount: stringDefaultToEmpty,
  accountNumber: stringDefaultToEmpty,
  sortCode: stringDefaultToEmpty,
  iban: stringDefaultToEmpty,
  swiftBic: stringDefaultToEmpty,
  verified: booleanDefaultToFalse,
  createdAt: firebaseDate,
  updatedAt: firebaseDate,
  isVerified: boolean().default(false),
});

export const dealerRiskProfileSchema = object({
  kybAmlStatus: string().default(() => "pending"),
  updatedAt: firebaseDate,
});
